import React, { ReactNode } from 'react';
import { createContext } from 'react';
import { ApiClient } from './apiClient';

export const ApiClientContext = createContext<ApiClient | undefined>(undefined);

type Props = {
  client: ApiClient;
  children?: ReactNode;
};

export const ApiClientProvider: React.FC<Props> = ({ client, children, ...props }) => {
  return <ApiClientContext.Provider value={client} {...props}>
      {children}
    </ApiClientContext.Provider>;
};
